import { ChatContent } from '../../types/Chat';

export function splitAssistantContent(content?: ChatContent[]) {
  const texts: string[] = [];
  const docs: string[] = [];

  for (const c of content ?? []) {
    if (c.type === 'text') {
      texts.push(c.text.trim());
    } else if (c.type === 'document') {
      docs.push(c.text.trim());
    }
  }

  return {
    textPlain: texts.length ? texts.join('\n') : undefined,
    documentRaw: docs.length ? docs.join('\n\n') : null,
  };
}
